import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import navigationReducer from './navigationReducer';
import clinicalReducer from './clinicalReducer';
import demographicReducer from './demographicReducer';
import ioTReducer from './ioTReducer';
import mailInboxReducer from './mailInboxReducer';
import UIElementsReducer from './UIElementsReducer';
import userReducer from './userReducer';
import patientReducer from './patientReducer';
import andrologyReducer from './andrologyReducer';
import dataAnalyticsReducer from './dataAnalyticsReducer';
import embryologyReducer from './embryologyReducer';
export default combineReducers({
  loginReducer,
  navigationReducer: navigationReducer,
  clinicalReducer: clinicalReducer,
  demographicReducer: demographicReducer,
  ioTReducer: ioTReducer,
  mailInboxReducer: mailInboxReducer,
  UIElementsReducer: UIElementsReducer,
  userReducer,
  patientReducer,
  andrologyReducer,
  dataAnalyticsReducer,
  embryologyReducer,
});
